import { ROUTE_INTERLOCUTOR } from './../constants/constant.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class InterlocutorService {

    constructor(
        private httpClient: HttpClient,
        private apiService: ApiService
    ) { }



    public sunat_importar_cliente(ruc: string): Observable<any> {
        return this.httpClient.put(environment.serviceUrl + "cliente/public/importar-cliente-sunat/" + ruc, null, { observe: 'response' });
    }

    public dni_importar_cliente(numero: string): Observable<any> {
        return this.httpClient.put(environment.serviceUrl + "cliente/public/importar/dni?numero="+ numero , null, { observe: 'response' });
    }


    getByCodInterlocutor(codcli: string) {
        return this.httpClient.get(environment.serviceUrl + "cliente/" + encodeURI(codcli), { observe: 'response' })
    }

    getGetByIdContactoInterlocutor(codcli: string, codcont: number) {
        return this.httpClient.get(environment.serviceUrl + "cliente/" + encodeURI(codcli) + "/contactos/" + codcont, { observe: 'response' })
    }

    obtenerContactos(codcli: string, activo: Boolean) {
        return this.httpClient.get(environment.serviceUrl + "cliente/" + encodeURI(codcli) + "/contactos?activo=" + activo, { observe: 'response' })
    }

    public direccion_envio_clases(): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "cliente/direcciones-envio/clases", { observe: 'response' });
    }

    public direccion_envio_clases_codigos(clase: number): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "cliente/direcciones-envio/clases/" + clase + "/codigos", { observe: 'response' });
    }

    public direccion_envio_obtener(codcli: string, codenv: number): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "cliente/" + encodeURI(codcli)  + "/direcciones-envio/" + codenv, { observe: 'response' });
    }
    public direccion_envio_actualizar(codcli: string, codenv: number, data: any): Observable<any> {
        return this.httpClient.put(environment.serviceUrl + "cliente/" + encodeURI(codcli)  + "/direcciones-envio/" + codenv, data, { observe: 'response' });
    }


    public clases_codigos(clase: number): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "cliente/clases/" + clase + "/codigos", { observe: 'response' });
    }


    obtenerInterlocutor(codcli: any, soloActivos: Boolean): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_INTERLOCUTOR.interlocutor);
        return this.apiService.execGetQueryJson(`/${codcli}` + ((soloActivos != null) ? ("?soloActivos=" + soloActivos) : ""))
    }

    getEECCGarantia(codcli: number, garantia: boolean, letratercero: boolean) {
        let fullUrl: any = null;
        fullUrl = environment.serviceUrl + `cliente/${codcli}/eecc.pdf?` + "garantia=" + garantia + "&letratercero=" + letratercero;
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.httpClient.get(fullUrl, httpOptions);
    }


    getdownloadPDFPendientesGarantia(params: any) {

        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
            //'responseType'  : 'blob' as 'json'        //This also worked
        };

        const fullUrl = environment.serviceUrl + `ctaporcobrar/consultas/estadocuenta/pendientegarantia/pdf`;
        return this.httpClient.post(fullUrl, params, httpOptions);
    }

    getdownloadPDFPendientesRepresentanteLegal(params: any) {

        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
            //'responseType'  : 'blob' as 'json'        //This also worked
        };

        const fullUrl = environment.serviceUrl + `ctaporcobrar/consultas/estadocuenta/pendienterepresentante/pdf`;
        return this.httpClient.post(fullUrl, params, httpOptions);
        
    }



    buscarInterlocutor(codcli: string, razonc: string, nombres: string, dident: string, soloactivos: boolean, limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_INTERLOCUTOR.interlocutor);
        return this.apiService.execGetQueryJson(`/buscar?codcli=${encodeURIComponent(codcli)}&razonc=${encodeURIComponent(razonc)}&nombres=${encodeURIComponent(nombres)}&dident=${dident}&soloactivos=${soloactivos}&limit=${limit}&offset=${offset}`)
    }

    buscarInterlocutorGeneral(tipcli: any, codcli: string, razonc: string, nombres: string, dident: string, soloactivos: boolean, limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_INTERLOCUTOR.interlocutor_general);
        return this.apiService.execGetQueryJson(`/buscar?tipcli=${tipcli}&codcli=${codcli}&razonc=${encodeURIComponent(razonc)}&nombres=${encodeURIComponent(nombres)}&dident=${dident}&soloactivos=${soloactivos}&limit=${limit}&offset=${offset}`)
    }

    insertContactoInterlocutor(codcli: any, condcot: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_INTERLOCUTOR.interlocutor + `/${codcli}/contactos/${condcot}`);
        return this.apiService.executePostJson(null);
    }

    insertContactoClaseInterlocutor(codcli: string, codcont: number, ParamsContactoClase: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_INTERLOCUTOR.interlocutor + `/${codcli}/contactos/${codcont}/clases`);
        return this.apiService.executePostJson(ParamsContactoClase).pipe();
    }

    updateContactoClaseInterlocutor(codcli: string, codcont: number, ParamsContactoClase: any): Observable<any> {
        return this.httpClient.put(environment.serviceUrl + "cliente/" + encodeURI(codcli) + "/contactos/" + codcont + "/clases", ParamsContactoClase, { observe: 'response' });
    }


    /*
    updateContactoClaseInterlocutor(codcli: string, codcont: number, ParamsContactoClase: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_INTERLOCUTOR.interlocutor + `/${codcli}/contactos/${codcont}/clases`);
        return this.apiService.executeDeleteJson(ParamsContactoClase)
    }
    */
    eliminar_contacto(codcli: any, condcot: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_INTERLOCUTOR.interlocutor);
        return this.apiService.executeDeleteJson(`/${codcli}/contactos/${condcot}`)
    }

    deleteContactoClaseInterlocutor(codcli: string, codcont: number, clase: number, codigo: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_INTERLOCUTOR.interlocutor);
        return this.apiService.executeDeleteJson(`/${codcli}/contactos/${codcont}/clases/${clase}/codigos/${codigo}`)
    }

    getCondicionesPago(codcli: any, condcot: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_INTERLOCUTOR.interlocutor);
        return this.apiService.execGetQueryJson(`/${codcli}/contactos/${condcot}`)
    }

    insertDireccionesEnvioInterlocutor(codcli: any, direccion: any) {
        this.apiService.setUrlPathApi(ROUTE_INTERLOCUTOR.interlocutor + `/${codcli}/direcciones-envio`);
        return this.apiService.executePostJson(direccion).pipe();
    }

    getEspecificaciones(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_INTERLOCUTOR.interlocutor);
        return this.apiService.execGetQueryJson(`/especificaciones`)
    }
    //PARA EL MÓDULO CLASES
    obtener_tipo_interlocutor() {
        this.apiService.setUrlPathApi("general/tipo-interlocutor");
        return this.apiService.execGetQueryJson('');
    }


    getdatosEECC(data: any): Observable<any> {
        return this.httpClient.post(environment.serviceUrl + "ctaporcobrar/consultas/clienteinput", data, { observe: 'response' });
    }



    // getCodigo(clase: number): Observable<any> {
    //     this.apiService.setUrlPathApi("cliente/clases/");
    //     return this.apiService.execGetQueryJson(`${clase}/codigos`)
    // }

    getCodigo(tipcli: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas/interlocutor-comercial');
        return this.apiService.execGetQueryJson(`/${tipcli}/clases/${clase}/codigos`)
    }

    insertarClaseCodigo(tipcli:any, data: any): Observable<any> {
        this.apiService.setUrlPathApi(`clases-genericas/interlocutor-comercial/${tipcli}/clases/codigos`);
        return this.apiService.executePostJson(data).pipe();
    }

    modificarClaseCodigo(tipcli:any, data: any): Observable<any> {
        this.apiService.setUrlPathApi(`clases-genericas/interlocutor-comercial/${tipcli}/clases/codigos`);
        return this.apiService.executePutJson(data).pipe();
    }

    eliminarClaseCodigo(tipcli: any, clase: any, codigo: any): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas/interlocutor-comercial');
        return this.apiService.executeDeleteJson(`/${tipcli}/clases/${clase}/codigos/${codigo}`)
    }
}